var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeh1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "meh",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10001",
    "data-name": "Path 10001",
    d: "M25,8A25,25,0,1,0,50,33,25,25,0,0,0,25,8ZM16.935,24.935a3.226,3.226,0,1,1-3.226,3.226A3.226,3.226,0,0,1,16.935,24.935ZM34.677,44.29H15.323a1.613,1.613,0,0,1,0-3.226H34.677A1.613,1.613,0,0,1,34.677,44.29Zm-1.613-12.9a3.226,3.226,0,1,1,3.226-3.226A3.226,3.226,0,0,1,33.065,31.387Z",
    fill: "#f7bf19",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10002",
    "data-name": "Path 10002",
    d: "M155.355,176a3.226,3.226,0,1,0,3.226,3.226A3.226,3.226,0,0,0,155.355,176Zm-16.129,0a3.226,3.226,0,1,0,3.226,3.226A3.226,3.226,0,0,0,139.226,176Z",
    transform: "translate(-122.29 -151.065)",
    fill: "#f7bf19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeh1);
export default __webpack_public_path__ + "static/media/meh-1.fe17a1b988a61c8c50c37cc3abac8b81.svg";
export { ForwardRef as ReactComponent };